;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="9cfa8ae9-1d75-4cce-8856-ace99cfbdac4",e._sentryDebugIdIdentifier="sentry-dbid-9cfa8ae9-1d75-4cce-8856-ace99cfbdac4")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6489],{

/***/ 86238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgCircleError(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#ff5768",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.78 9.5h.44c.1 0 .2-.1.2-.2l.52-3.61V4.24c0-.12-.1-.24-.2-.24H7.26c-.1 0-.2.12-.2.24v1.47l.52 3.59c0 .1.1.2.2.2zM7 11.49a1 1 0 00.99 1c.55 0 1.01-.46 1.01-1s-.46-1-1.01-1c-.54 0-.99.46-.99 1z",
    fill: "#FFF"
  }))));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCircleError);

/***/ }),

/***/ 29867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Group = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pb-4",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Group);


/***/ }),

/***/ 49868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44012);
/* harmony import */ var _assets_icons_animated_spinner_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48110);
/* harmony import */ var _assets_icons_circle_error_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86238);
/* harmony import */ var _group__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29867);
/* harmony import */ var _label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83484);
/* harmony import */ var _validation_errors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85370);












var Input = function(_param) {
    var className = _param.className, placeholder = _param.placeholder, helper = _param.helper, required = _param.required, formState = _param.formState, register = _param.register, label = _param.label, labelClass = _param.labelClass, _showIcon = _param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, name = _param.name, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "className",
        "placeholder",
        "helper",
        "required",
        "formState",
        "register",
        "label",
        "labelClass",
        "showIcon",
        "name"
    ]);
    var ref;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    if (!formState) return null;
    var errors = formState.errors, isValidating = formState.isValidating, touchedFields = formState.touchedFields, isSubmitted = formState.isSubmitted;
    var touched = touchedFields[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_group__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_label__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: labelClass,
                required: required,
                htmlFor: name,
                children: typeof label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    id: label
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, register(name)), {
                        id: name,
                        "data-test": "input-".concat(name),
                        type: inputProps.type,
                        placeholder: placeholder && intl.formatMessage({
                            id: placeholder
                        }),
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(" h-12 w-full rounded-lg border border-grey-300 bg-grey-50 px-4 py-3 text-base leading-tight text-text-light-bg-secondary hover:border-2 hover:border-grey-300 focus:border-2 focus:border-primary-main focus:outline-hidden", className, touched && "border-2 border-primary-main", errors[name] && isSubmitted && "border-2 border-red-400 hover:border-red-400 focus:border-red-400")
                    })),
                    showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute bottom-0 right-0 top-0 flex h-full w-8 items-center ",
                        children: isValidating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_animated_spinner_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "h-auto w-5 text-grey-200"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: errors[name] && isSubmitted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_circle_error_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: "h-auto w-4"
                            })
                        })
                    })
                ]
            }),
            isSubmitted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_validation_errors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                errors: (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message,
                helper: helper,
                isSubmitted: isSubmitted
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 83484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var Label = function(_param) {
    var htmlFor = _param.htmlFor, required = _param.required, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "htmlFor",
        "required",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        htmlFor: htmlFor,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("text-xs font-black uppercase tracking-wide text-primary-main	", className)
    }, props), {
        children: [
            children,
            required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                className: "ml-px align-text-top text-xl leading-3 text-red-600",
                children: "*"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Label);


/***/ }),

/***/ 85370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);



var ValidationErrors = function(param) {
    var errors = param.errors, helper = param.helper, isSubmitted = param.isSubmitted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: errors && isSubmitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "pt-1 text-xs text-text-light-bg-discounted-price",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "validation:".concat(errors)
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: helper && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-1 text-xs text-text-light-bg-secondary",
                children: helper
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationErrors);


/***/ }),

/***/ 10562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Canonical = function(url) {
    var omitSlash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var pageUrl;
    if (omitSlash) {
        pageUrl = "".concat("https://www.petsdeli.de").concat(url);
    } else {
        pageUrl = "".concat("https://www.petsdeli.de", "/").concat(url);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:url",
                property: "og:url",
                content: pageUrl
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Canonical);


/***/ }),

/***/ 9960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);



var Description = function(description) {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var defaultDescription = intl.formatMessage({
        id: "seo:default-description"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "description",
                name: "description",
                content: description || defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                name: "twitter:description",
                content: description || defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                name: "og:description",
                content: description || defaultDescription
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);


/***/ }),

/***/ 31296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Image = function(image) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:src",
                property: "twitter:image:src",
                content: image || "https://www.petsdeli.de/images/share-catdog.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image",
                property: "og:image",
                content: image || "https://www.petsdeli.de/images/share-catdog.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image:secure_url",
                property: "og:image",
                content: image || "https://www.petsdeli.de/images/share-catdog.jpg"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 6126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Type = function(type) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
        name: "og:type",
        property: "og:type",
        content: type || "website"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Type);


/***/ }),

/***/ 88775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_experience_wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31556);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_type_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79221);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92918);
/* harmony import */ var _sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35268);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40009);








var ContentCmsContentStatic = function() {
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_4__/* .useContentful */ .G)(), contentful = ref.data;
    var sections = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return ((ref = contentful.fields.sections) === null || ref === void 0 ? void 0 : ref.filter(utils_type_helper__WEBPACK_IMPORTED_MODULE_5__/* .omitNullableHandler */ .vc)) || [];
    }, [
        contentful
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: sections.map(function(section, index) {
            // This entry is either
            // - deleted
            // - archived
            // - unpublished
            if (!section.sys.contentType) {
                return "";
            }
            if ("productInformationTab" in section.fields && section.fields.productInformationTab) return "";
            var componentIdentifier = (0,_utils_strings__WEBPACK_IMPORTED_MODULE_6__/* .capitalize */ .kC)(section.sys.contentType.sys.id);
            if (typeof _sections__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[componentIdentifier] === "undefined") {
                if (false) {}
                console.warn("Missing template for contentful section", componentIdentifier);
                return "";
            }
            var Component = _sections__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[componentIdentifier];
            if (typeof section.fields["nt_experiences"] !== "undefined") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_experience_wrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    component: Component,
                    entry: section
                }, section.sys.id);
            } else {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    id: section.sys.id
                }, section.fields), section.sys.id);
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentCmsContentStatic);


/***/ }),

/***/ 40009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useContentful; },
/* harmony export */   "i": function() { return /* binding */ ContentfulProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_middleware_laggy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39143);
/* harmony import */ var connectors_contentful__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6593);
/* harmony import */ var contexts_segmentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42067);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29804);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8100);









var ContentfulContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createContext({});
var ContentfulProvider = function(param) {
    var children = param.children, fallbackData = param.fallbackData, _isProductPage = param.isProductPage, isProductPage = _isProductPage === void 0 ? false : _isProductPage, shopifyData = param.shopifyData, handle = param.handle, _query = param.query, query = _query === void 0 ? null : _query;
    var pushSegmentation = (0,contexts_segmentation__WEBPACK_IMPORTED_MODULE_3__/* .useSegmentationContext */ .M)().pushSegmentation;
    var q = react__WEBPACK_IMPORTED_MODULE_5__.useMemo(function() {
        return query;
    }, [
        query
    ]);
    var _obj;
    // Pre-rendering with Default Data
    // See https://swr.vercel.app/docs/with-nextjs#pre-rendering-with-default-data
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(q === null ? handle : [
        handle,
        q
    ], isProductPage ? connectors_contentful__WEBPACK_IMPORTED_MODULE_2__/* .fetchContentfulProductPage */ .ZY : function(handle, q2) {
        return (0,connectors_contentful__WEBPACK_IMPORTED_MODULE_2__/* .fetchContentfulByHandle */ .sm)(handle, q2);
    }, {
        // https://github.com/vercel/swr/issues/1520#issuecomment-932339824
        fallback: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, (0,swr__WEBPACK_IMPORTED_MODULE_6__/* .unstable_serialize */ .wE)(q === null ? handle : [
            handle,
            q
        ]), fallbackData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "use", [
            api_middleware_laggy__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
        ]), _obj)
    }), error = ref.error, data = ref.data;
    var shopifyCollectionMap = react__WEBPACK_IMPORTED_MODULE_5__.useMemo(function() {
        var shopifyCollectionData = shopifyData["collectionMap"];
        return shopifyCollectionData;
    }, [
        shopifyData
    ]);
    var shopifyProductDetailMap = react__WEBPACK_IMPORTED_MODULE_5__.useMemo(function() {
        return shopifyData["productDetailMap"];
    }, [
        shopifyData
    ]);
    // If a segment is assigned to a page in Contentful, this will be pushed to the segmentation context
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        var ref;
        if ((ref = fallbackData.fields) === null || ref === void 0 ? void 0 : ref.assignSegmentation) {
            pushSegmentation({
                segmentation: fallbackData.fields.assignSegmentation
            });
        }
    }, [
        fallbackData.fields,
        pushSegmentation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulContext.Provider, {
        value: {
            shopifyCollectionMap: shopifyCollectionMap,
            shopifyProductDetailMap: shopifyProductDetailMap,
            data: data
        },
        children: !error && !data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                id: "common:loading"
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: data ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_4__["default"], {})
        })
    });
};
function useContentful() {
    return react__WEBPACK_IMPORTED_MODULE_5__.useContext(ContentfulContext);
}



/***/ }),

/***/ 96118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ninetailed_experience_js_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30941);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_ninetailed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56153);
/* harmony import */ var utils_type_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79221);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92918);
/* harmony import */ var _sections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35268);
/* harmony import */ var _sections_components_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10472);
/* harmony import */ var _sections_slider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2552);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40009);












/**
 * Renders header field in product page.
 * For the purpose of rendering Section field, use ContentCmsContentStatic
 * @see : src/modules/content-cms/components/content/index.tsx
 */ var ContentCmsHeaderContentStatic = function(param) {
    var children = param.children, priority = param.priority, _overrideSliderDesign = param.overrideSliderDesign, overrideSliderDesign = _overrideSliderDesign === void 0 ? false : _overrideSliderDesign;
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_7__/* .useContentful */ .G)(), contentful = ref.data;
    var headerData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return ((ref = contentful.fields.header) === null || ref === void 0 ? void 0 : ref.filter(utils_type_helper__WEBPACK_IMPORTED_MODULE_8__/* .omitNullableHandler */ .vc)) || [];
    }, [
        contentful
    ]);
    /**
   * For Header we need to filter entries with contentType "usp" and "slide" from header array
   * and display them seperately for backwards compatibility
   * Because "slide" and "usp" could be injected directly without it being wrapped with slider and
   * Rest of the sections can be displayed normally
   */ var slides = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return headerData.filter(function(headerEntry) {
            return headerEntry.sys.contentType.sys.id === "slide";
        }) || [];
    }, [
        headerData
    ]);
    var usps = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return headerData.filter(function(headerEntry) {
            return headerEntry.sys.contentType.sys.id === "usp";
        }) || [];
    }, [
        headerData
    ]);
    if (headerData.length === 0 && children) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            slides.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_slider__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                priority: priority,
                slides: slides,
                autoplay: false
            }),
            usps.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "-mx-2 flex flex-wrap justify-between pt-4 lg:flex-nowrap",
                children: usps.map(function(usp) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-1/2 flex-col items-center px-2 pt-3 lg:w-full lg:max-w-xs lg:flex-row lg:pt-0",
                        children: [
                            usp.fields.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto mb-2 w-10 text-primary-main lg:mx-0 lg:mb-0 lg:w-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_components_image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, usp.fields.icon), {
                                    className: "h-auto"
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-center text-sm leading-tight text-text-light-bg-secondary lg:pl-4 lg:text-left lg:text-base",
                                children: usp.fields.text && usp.fields.text
                            })
                        ]
                    }, usp.sys.id);
                })
            }),
            headerData.map(function(section) {
                var componentIdentifier = (0,_utils_strings__WEBPACK_IMPORTED_MODULE_11__/* .capitalize */ .kC)(section.sys.contentType.sys.id);
                // Don't show slides or usps again
                if (section.sys.contentType.sys.id === "usp" || section.sys.contentType.sys.id === "slide") {
                    return "";
                }
                if ("productUsp" in section.fields && section.fields.productUsp) return "";
                if (typeof _sections__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[componentIdentifier] === "undefined") {
                    if (false) {}
                    console.warn("T-Miss:", componentIdentifier);
                    return "";
                }
                var Component = _sections__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[componentIdentifier];
                // TO DO: This condition has been added becaause the ExperienceWrapper cause flickering with some components
                // Need to find a better solution to fix this.
                // @see: https://petsdeli.atlassian.net/browse/PT-5596
                if (typeof section.fields["nt_experiences"] !== "undefined") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ninetailed_experience_js_next__WEBPACK_IMPORTED_MODULE_1__/* .Experience */ .a3, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, section.fields), {
                        id: section.sys.id,
                        experiences: (0,utils_ninetailed__WEBPACK_IMPORTED_MODULE_3__/* .parseExperiences */ .zw)({
                            entry: section
                        }),
                        component: Component,
                        passthroughProps: {
                            overrideSliderDesign: overrideSliderDesign,
                            priority: priority
                        }
                    }), section.sys.id);
                } else {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, section.fields), {
                        overrideSliderDesign: overrideSliderDesign,
                        priority: priority
                    }), section.sys.id);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentCmsHeaderContentStatic);


/***/ }),

/***/ 29804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/seo/title/index.tsx
var title = __webpack_require__(89469);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/components/not-found-page/index.tsx





var NotFound = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,title/* default */.Z)(intl.formatMessage({
                    id: "error:page:page-title:page-not-found"
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mb-10 flex flex-col items-center justify-center py-10",
                style: {
                    minHeight: "40vh"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Pets Deli",
                                className: "mb-4 mr-auto lg:mr-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/petsdeli-logo.svg",
                                    className: "w-auto",
                                    alt: "Pets Deli",
                                    role: "presentation"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-3xl font-black text-primary-main ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "error:page:header"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "py-4 text-primary-main",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "error:page:suggestions:header"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mb-3 text-brand-blue-neu underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "error:page:suggestions:home"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/pages/".concat("unsere-futterberatung-online-und-telefonisch"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mb-3 text-brand-blue-neu underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "error:page:suggestions:foodaid"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/account",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mb-3 text-brand-blue-neu underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "error:page:suggestions:account"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/cart",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mb-3 text-brand-blue-neu underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "error:page:suggestions:cart"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var not_found_page = (NotFound);

// EXTERNAL MODULE: ./src/contexts/translations.tsx + 54 modules
var translations = __webpack_require__(41967);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/404.tsx




var Error = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(translations/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found_page, {})
    });
};
/* harmony default export */ var _404 = (Error);


/***/ }),

/***/ 70738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ checkSegmentationMatch; }
/* harmony export */ });
/* harmony import */ var constants_segmentation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6813);
/* harmony import */ var _convert_segmentation_to_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62226);


/**
 * Check if segmentation id matches with current pet type
 */ var checkSegmentationMatch = function(param) {
    var currentPetType = param.currentPetType, segmentation = param.segmentation, _keysToOmit = param.keysToOmit, keysToOmit = _keysToOmit === void 0 ? [
        "allergySegmentation"
    ] : _keysToOmit;
    if (typeof segmentation === "object") {
        return (0,_convert_segmentation_to_array__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            store: segmentation,
            keysToOmit: keysToOmit
        }).some(function(v) {
            return checkMatch({
                segmentationId: v,
                currentPetType: currentPetType
            });
        });
    }
    return checkMatch({
        segmentationId: segmentation,
        currentPetType: currentPetType
    });
};
var checkMatch = function(param) {
    var currentPetType = param.currentPetType, segmentationId = param.segmentationId;
    if (!currentPetType) {
        return false;
    }
    if ((0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isCatSegmentation */ .no)(segmentationId)) {
        return currentPetType === "cats";
    } else {
        return currentPetType === "dogs";
    }
};


/***/ })

}]);